import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-travel-bill-logs',
  templateUrl: './travel-bill-logs.component.html',
  styleUrls: ['./travel-bill-logs.component.css']
})
export class TravelBillLogsComponent implements OnInit {
    travelBillNo;

    public itemsListLogs: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.travelBillNo = this.stateService.getStateParams()['travelbill_no'];
    }

    private async loadLogs() {
        if (!!this.travelBillNo) {
            this.itemsListLogs = await this.datatask.Post(1623, { travelbill_no: this.travelBillNo });
        }
    }

    private async init() {
        this.loadLogs();
    }

    ngOnInit() {
        this.init();
    }
}
